
import React from "react";
import { 
  AlertDialog, 
  AlertDialogAction, 
  AlertDialogCancel, 
  AlertDialogContent, 
  AlertDialogDescription, 
  AlertDialogFooter, 
  AlertDialogHeader, 
  AlertDialogTitle 
} from "@/components/ui/alert-dialog";
import { MedewerkerResponse } from "@/integrations/supabase/client";

interface DeleteMedewerkerDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  medewerker: MedewerkerResponse | null;
  onDelete: (id: string) => void;
  isDeleting: boolean;
}

const DeleteMedewerkerDialog = ({
  isOpen,
  onOpenChange,
  medewerker,
  onDelete,
  isDeleting
}: DeleteMedewerkerDialogProps) => {
  if (!medewerker) return null;

  return (
    <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Medewerker verwijderen</AlertDialogTitle>
          <AlertDialogDescription>
            Weet je zeker dat je {medewerker.naam} wilt verwijderen? 
            Deze actie kan niet ongedaan worden gemaakt.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={() => onOpenChange(false)} disabled={isDeleting}>
            Annuleren
          </AlertDialogCancel>
          <AlertDialogAction 
            onClick={() => onDelete(medewerker.id)}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
            disabled={isDeleting}
          >
            {isDeleting ? "Bezig..." : "Verwijderen"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteMedewerkerDialog;
